export const ADJUST_LINE_ITEM_QUANTITIES = 'ADJUST_LINE_ITEM_QUANTITIES'
export const ADJUST_LINE_ITEM_QUANTITIES_SUCCEEDED = 'ADJUST_LINE_ITEM_QUANTITIES_SUCCEEDED'
export const ADJUST_LINE_ITEM_QUANTITIES_FAILED = 'ADJUST_LINE_ITEM_QUANTITIES_FAILED'

export const adjustLineItemQuantities = (payload = {}) => ({
  type: ADJUST_LINE_ITEM_QUANTITIES,
  payload,
})

export const adjustLineItemQuantitiesSucceeded = (payload = {}) => ({
  type: ADJUST_LINE_ITEM_QUANTITIES_SUCCEEDED,
  payload,
})

export const adjustLineItemQuantitiesFailed = (payload = {}) => ({
  type: ADJUST_LINE_ITEM_QUANTITIES_FAILED,
  payload,
})
